module.exports = __webpack_public_path__ + "img/header-navigation-below-lincoln.e36a4424.png";